import React, { useEffect, useContext } from 'react'
import ChooseProducts from './ChooseProducts'
import FirstStep from './FirstStep'
import PaymentScreen from './PaymentScreen'
import Loader from '../Loader/Loader'
import SubmitScreen from './SubmitScreen'
import calculateTax from '../Functions/calculateTax'

import { ProductContext } from '../Context/Context'

export const Main = (props) => {

	const {
		products,
		settings,
		bestellung,
		setBestellung,
		loading,
		region,
		step,
		setStep,
		 } = useContext(ProductContext)




	useEffect(() => {
		const nettoTotal = bestellung.totals.totalAmount / 100 * (bestellung.totals.marge + parseFloat(bestellung.basePrice) + parseFloat(bestellung.aufpreis) + parseFloat(bestellung.totals.productExtra ? bestellung.totals.productExtra : 0) - parseFloat(bestellung.totals.aktion ? bestellung.totals.aktion : 0))
		
		setBestellung({
			...bestellung,
			totals: {
				...bestellung.totals,
				totalNetto: nettoTotal,
				totalBrutto: parseFloat(calculateTax(nettoTotal))
			}
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [bestellung.totals.totalAmount])
	
	return (
		<div className="no__maincontent">

			{
				step === 1 &&
				<FirstStep
					handleUpdate={setBestellung}
					region={region}
					bestellung={bestellung}
					settings={settings}
					next={props.next}
					api={props.api}
			
					
				/>
			}
			{
				step === 2 &&
				<ChooseProducts
					products={products}
					next={props.next}
					handleUpdate={setBestellung}
					bestellung={bestellung}
				
					
				/>
			}
			{
				step === 3 &&
				<PaymentScreen
					bestellung={bestellung}
					handleUpdate={setBestellung}
					region={region}
					next={props.next}
					settings={settings[region.region]}
					setStep={setStep}
					step={ step}
				/>
			}
			{
				step === 4 &&
				<SubmitScreen
					bestellung={bestellung}
					handleChange={setBestellung}
					next={props.next}
					setStep={setStep}
					path={props.path}
					settings={settings}
					step={ step}
				/>
			}
			{loading && <Loader />}
			
			
		</div>
	)
}
